import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HitItemLink = styled.a`
  display: flex;
  align-items: start;
  flex-direction: row;
  padding: ${Spacing.S12} ${Spacing.S16};
`

export const HitItemLeft = styled.div`
  flex: 1 1 auto;
`
